import { z } from "zod";
//#region src/platform-channel-list.ts
/**
* The platform channel list of release-engine, `GET /v1/platform/channels`
* (`PlatformChannelsService.listEnriched`; plan 2026-10-21-operator-tui, R-054e, F1). The
* `zion-ops` verbs read it to turn a channel name into its id.
*/
/** The version of one app on the channel. `compositionId` is `null` for a pin with no composition. */
const platformChannelAppVersionSchema = z.object({
	version: z.string().min(1),
	compositionId: z.string().nullable()
}).strict();
/**
* One platform channel: the `release_channels` row and the three values that `enrichChannel` adds.
* `appVersions` is keyed by app name (`platform` for the DP platform bundle). `subscriberCount`
* counts the active and ready data planes on the channel. The CP answers `0` for a count when it
* could not read the rows that count depends on. When the pending-config check fails for one app,
* the CP skips that app and still counts the other apps, so `pendingConfigCount` can be low.
*/
const platformChannelSchema = z.object({
	id: z.uuid(),
	name: z.string().min(1),
	description: z.string().nullable(),
	createdAt: z.iso.datetime(),
	autoUpgrade: z.boolean(),
	appVersions: z.record(z.string(), platformChannelAppVersionSchema),
	subscriberCount: z.number().int().nonnegative(),
	pendingConfigCount: z.number().int().nonnegative()
}).strict();
/** The answer of the list route, ordered by name. Names are unique (`release_streams_name_key`). */
const platformChannelListSchema = z.array(platformChannelSchema);
//#endregion
export { platformChannelAppVersionSchema, platformChannelListSchema, platformChannelSchema };

//# sourceMappingURL=platform-channel-list.js.map